import React, { createContext, useContext } from "react";
import { message } from "antd";

const MessageContext = createContext(null);

export const AppMessageProvider = ({ children }) => {
    const [messageApi, contextHolder] = message.useMessage();
    return (
        <MessageContext.Provider value={messageApi}>
            {contextHolder}
            {children}
        </MessageContext.Provider>
    );
};

export const useAppMessage = () => {
    const ctx = useContext(MessageContext);
    if (!ctx) {
        throw new Error("useAppMessage must be used inside <AppMessageProvider>");
    }
    return ctx;
};